<template>
    <div class="register-page">
        <div class="register-title">四川省知识产权发展研究中心专利价值评估系统</div>
        <div class="register-title-en">Sichuan Intellectual Property Development Research Center Patent Value Evaluation System</div>
        <!-- 用户登录 -->
        <div class="transition-box">
            <div class="register-content">
                <div class="login-type">
                    <div @click="login_type=1" :class="login_type==1 ? 'type_1 type_active': 'type_1'">密码登录</div> 
                    <div @click="login_type=2" :class="login_type==2 ? 'type_1 type_active': 'type_1'">验证码登录</div>
                </div>
                <el-form v-if="login_type==1" label-position="top" label-width="auto" class="register-form" :rules="loginFormRules" :model="loginFormData" ref="loginFormData">
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model.trim="loginFormData.mobile" maxlength="11" clearable />
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model.trim="loginFormData.password" type="password" clearable />
                    </el-form-item>
                    <el-form-item class="login-btn">
                        <el-button type="primary" style="background-color: #2A91DD;" @click="commitLogin('loginFormData')">登录</el-button>
                    </el-form-item>
                </el-form>
                <div v-if="login_type==1" class="bottom-title">
                    <!-- <span class="forget-text" @click="showResetPsd()">忘记密码？</span> -->
                    <span class="forget-text" style="padding-left: 6px;" @click="goIndex()">返回首页</span>
                </div>
                <el-form v-if="login_type==2" label-position="top" label-width="auto" class="register-form" :rules="loginCodeFormRules" :model="loginCodeFormData" ref="loginCodeFormData">
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model.trim="loginCodeFormData.mobile" maxlength="11" clearable />
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model.trim="loginCodeFormData.code" clearable style="width: 160px !important;" />
                        <el-button v-if="codeSeconds <= 0" type="primary" style="margin-left: 14px;width: 100px !important;background-color: #2A91DD;" @click="getLoginCode()">验证码</el-button>
                        <el-button v-else type="primary" disabled key="x" style="margin-left: 14px;width: 100px !important;">{{ codeSeconds }}s</el-button>
                    </el-form-item>
                    <el-form-item class="login-btn">
                        <el-button type="primary" style="background-color: #2A91DD;" @click="commitCodeLogin('loginCodeFormData')">登录</el-button>
                    </el-form-item>
                </el-form>
                <div v-if="login_type==2" class="bottom-title">
                    <!-- <span class="register-text" @click="showPersonRegister()">注册账号</span> -->
                    <span class="forget-text" @click="goIndex()">返回首页</span>
                </div>
            </div>
        </div>
        <bottomNav></bottomNav>
    </div>
</template>
<script type="text/ecmascript-6">
import { 
    agentLogin,
    getVerifyCode,
    userLogin
 } from '../../api/evalMG'
import md5 from 'js-md5'
import bottomNav from '../../components/bottomNav'
export default {
    name: 'register',
    data() {
    return {
        title: '专利申请预评估系统（专家端)',
        personLogin: true,
        personRegister: false,
        personResetPsd: false,
        sign: 'admin',// 入口标记，默认是用户
        login_type: 1,
        codeSeconds: 0,// 倒计时秒数
        timer: null, // 定时器引用
        loginFormData: {
            mobile: '',
            password: ''
        },
        loginCodeFormData: {
            mobile: '',
            code: ''
        },
        loginFormRules: {
            mobile:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
            password:[{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
        loginCodeFormRules: {
            mobile:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
            code:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
        },
      }
    },
    // 注册组件
    components: {
        bottomNav
    },
    // 创建完毕状态(里面是操作)
    created() {

    },
    mounted() {

    },
    // 里面的函数只有调用才会执行
    methods: {
        // 获取登录验证码
        getLoginCode(){
            let mobile = this.loginCodeFormData.mobile
            if(mobile.length <= 0){
                this.$message({
                    type: 'warning',
                    message: '手机号不能为空!'
                }) 
                return false
            }
            // 调用接口,获取验证码
            let param = {
                mobile: mobile,
                scene: 'login',
                sign: 'agent'
            }
            getVerifyCode(param)
            .then(res=>{
                if(res.code == 200){
                    this.$message({
                        type: 'success',
                        message: res.msg
                    }) 
                    // 验证码获取成功
                    this.codeSeconds = 60; // 设置初始秒数
                    this.timer = setInterval(() => {
                        if (this.codeSeconds > 0) {
                            this.codeSeconds -= 1;
                        } else {
                            clearInterval(this.timer); // 清除定时器
                            this.timer = null; // 重置定时器引用
                        }
                    }, 1000); // 每1000毫秒（1秒）减少1秒
                }else{
                    this.$message({
                        type: 'info',
                        message: res.msg
                    }) 
                }
            })
        },
        beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); // 在组件销毁前清除定时器，防止内存泄漏
            }
        },

        // 用户登录
        commitLogin(loginFormData){
            this.$refs[loginFormData].validate(valid => {
                if(valid){
                    let param = {
                        type: 1,
                        mobile: this.loginFormData.mobile,
                        password: md5(this.loginFormData.password)
                    }
                    userLogin(param)
                    .then(res=>{
                        if(res.code == 200){
                            this.$message({
                                type: 'success',
                                message: res.msg
                            })
                            // 登录成功,保存token到本地缓存
                            localStorage.setItem('userToken', res.data.token)
                            localStorage.setItem('sign', 'agent')
                            this.$router.push({ path: '/agent/waitEval'});
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                }else{
                    return false
                }
            })
            // this.$router.push({ path: '/customer/applyEval'});
        },
        // 用户验证码登录
        commitCodeLogin(loginCodeFormData){
            this.$refs[loginCodeFormData].validate(valid => {
                if(valid){
                    let param = {
                        type: 2,
                        mobile: this.loginCodeFormData.mobile,
                        code: this.loginCodeFormData.code
                    }
                    agentLogin(param)
                    .then(res=>{
                        if(res.code == 200){
                            this.$message({
                                type: 'success',
                                message: res.msg
                            })
                            // 登录成功,保存token到本地缓存
                            localStorage.setItem('userToken', res.data.token)
                            localStorage.setItem('sign', 'agent')
                            this.$router.push({ path: '/agent/waitEval'});
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                }else{
                    return false
                }
            })
            
        },
        // 返回首页
        goIndex(){
            this.$router.push({ path: '/login'});
        },
        // 显示重设密码页面
        showResetPsd(){
            this.personLogin = false,
            this.personRegister = false,
            this.personResetPsd = true
        }
    }
}
</script>
<style scoped>
    .register-page {
        text-align: center;
        height: 100%;
    }
    .register-title {
        font-size: 36px;
        font-weight: 700;
        padding-top: 120px;
    }
    .register-title-en {
        font-size: 16px;
        color: #5a5a5a;
        margin-top: 10px;
    }
    .register-content {
        width: 400px;
        height: 450px;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px rgba(206, 199, 224, 0.66);
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin: 40px auto;
    }
    .login-bottom {
        width: 100%;
        position: absolute;
        bottom: 40px;
        font-size: 12px;
        text-align: center;
    }
    .login-type{
        display:flex;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        margin:24px auto;
        display:flex;
        align-items:center;
        height:30px;
    }
    .type_1 {
        width: 120px;
        text-align: center;
        cursor: pointer;
    }
    .type_active {
      font-weight: 700;
      color:#333333
    }
    .register-form {
        width: 280px;
        text-align: left;
    }
    .register-form>>>.el-form-item {
        margin-bottom: 10px !important;
    }
    .register-form>>>.el-input__inner {
        border-radius: 4px !important;
        background-color: #ecedf4 !important;
        height: 36px !important;
    }
    .bottom-title {
        font-size: 12px;
        margin-top: 30px;
    }
    .bottom-title-zc {
        font-size: 12px;
        margin-top: 10px;
    }
    .forget-text {
        cursor: pointer;
    }
    .register-text {
        cursor: pointer;
        color: #2a91dd;
    }
    .login-btn>>>.el-button {
        width: 280px !important;
        margin-top: 20px !important;
    }
    .register-btn>>>.el-button {
        width: 280px !important;
        margin-top: 10px !important;
    }
    .el-form-item__label {
        line-height: 0px !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/login/agentLogin.vue